import { ScopeElementsConfig } from '../../models/scope-elements-config.interface'
import { ValueDiff } from '../../models/entities-with-changes/value-diff.interface'
import { isNil } from 'lodash'
import { EntityWithChanges, EntityChanges } from '../../models/entities-with-changes/entity-with-changes.type'

export function showCrDifferences<T>(config: ScopeElementsConfig, element: EntityWithChanges<T>, fieldName: string) {
  return config?.isChangeRequest && config?.showDiff && isDifferent(element?.changes?.[fieldName])
}

const isDifferent = (value: ValueDiff): boolean => !isNil(value) && value?.new !== value?.old

export function showCrNetChanges(config: ScopeElementsConfig, isAddedOrRemoved: boolean, diff: ValueDiff): boolean {
  return (
    !!(config?.isChangeRequest && config?.showNetDelta) && (isAddedOrRemoved || (!isNil(diff) && diff.new !== diff.old))
  )
}

export function getCrNetChanges(
  changes: EntityChanges | undefined,
  fieldName: string,
  defaultValue: number | null | undefined,
  isAdded?: boolean,
  isRemoved?: boolean
): number {
  if (isAdded) return defaultValue ?? 0
  if (isRemoved) return -(defaultValue ?? 0)
  const diff = changes?.[fieldName]
  return diff ? (diff.new ?? 0) - (diff.old ?? 0) : 0
}
